// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompactCallView__container-a85cab {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  width: 360px;
  position: relative;
  background-color: var(--addition-80);
}

.CompactCallView__own-video-container-c1da93 {
  position: absolute;
  top: 72px;
  inset-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/CompactCallView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  width: 360px;\n  position: relative;\n  background-color: var(--addition-80);\n}\n\n.own-video-container {\n  position: absolute;\n  top: 72px;\n  inset-inline-end: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CompactCallView__container-a85cab`,
	"own-video-container": `CompactCallView__own-video-container-c1da93`,
	"ownVideoContainer": `CompactCallView__own-video-container-c1da93`
};
module.exports = ___CSS_LOADER_EXPORT___;
